<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="addColumns"
    ></page-template>
  </div>
</template>

<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';

export default {
  components: {
    pageTemplate
  },
  data() {
    return {
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {label: '单位名称', prop: 'name', type: 'input', isFuzzy: true, placeholder: '请输入单位名称'}
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '新增',
          code: 'insert'
        },
        {
          label: '删除',
          code: 'delete',
          type: this.$utils.buttonType.tableOperate
        }
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true,
        columns: [
          {label: '单位名称', prop: 'name', width: '120', align: 'center'},
          // {label: '创建人', prop: 'createBy', width: '120', align: 'center'},
          {label: '创建时间', prop: 'createDttm', width: '125', align: 'center'}
        ],
        url: api.archives.goodsUnit
      },
      // 添加字段
      addColumns: {
        labelWidth: '120px',
        span: 12,
        columns: [
          {
            label: '单位名称',
            type: 'input',
            maxLength: 8,
            prop: 'name',
            rule: [
              {required: true, message: '请输入单位名称', trigger: 'blur'}
            ],
            placeholder: '请输入品牌名称'
          },
          {
            label: '备注',
            type: 'textarea',
            maxLength: 16,
            prop: 'remarks',
            span: 22
          }

        ], // 表单label
        url: api.archives.goodsUnit
      }
    };
  },
  created() {
  },
  methods: {}
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/archives/goods/Unit.vue